import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { message, Spin } from "antd";
import { CONSTANTS } from "../utils/constants";
import { clearTestStorage } from "../utils/common";

const TokenGuard = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const PAGENOTFOUNDURL = "/page-not-found";
  const tokenFromUrl = window.location.search.replace("?", "")?.trim();
  const extractedToken = tokenFromUrl?.split('=')?.[1] || ''

  const pageNotFound = () => {
    clearTestStorage()
    navigate(PAGENOTFOUNDURL);
  }

  useEffect(() => {
    const token = extractedToken || sessionStorage.getItem("token") || ''
    if (!token) {
      pageNotFound();
      return;
    }

    const verifyToken = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/validate-babcws-token/${token}`,
        {
          method: 'GET',
          credentials: 'include',
        });
        const data = await res.json();
        if (!data) {
          pageNotFound();
          return
        }

        let isValidToken = data?.valid_token;
        if (isValidToken) {
          setLoading(false);
          sessionStorage.setItem('token', token)
          window.history.replaceState({}, document.title, window.location.pathname);
        } else {
          message.error(CONSTANTS.SESSIONEXPIRED);
          clearTestStorage();
          sessionStorage.removeItem('token');
          pageNotFound();
        }
      } catch (err) {
        message.info('Error caught. Please check developer console.');
        pageNotFound();
      }
    };
    verifyToken();
  }, [navigate]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20%" }}>
        <Spin tip={CONSTANTS.CHECKACCESS} />
      </div>
    );
  }
  return children;
};

export default TokenGuard;
